import { useEffect, useState } from "react";
import manager from "../../Manager";
import axios from "axios";
import Utils from '../../CourseApp/Helper/utils';

// reference https://docs.bunny.net/docs/stream-embedding-videos
function VideoPreviewBunnynet({ videoData, customHeight, type }) {
    const [isMounted, setIsMounted] = useState(false);
    const baseUrl = manager.settings.baseUrl;
    const generateBunnynetToken = baseUrl + '/generateStreamToken';
    const [directPlayUrlWithToken, setDirectPlayUrlWithToken] = useState(videoData.directPlayUrl);

    useEffect(() => {
        async function fetchStreamToken() {
            try {
                const { data } = await axios.post(generateBunnynetToken, {
                    videoId: videoData.guid
                });
                let responseData = data.data;
                let directPlayUrlWithTokenGenerated = `${videoData.directPlayUrl}?token=${responseData.token}&expires=${responseData.expires}&autoplay=false`;
                setDirectPlayUrlWithToken(directPlayUrlWithTokenGenerated);
                if (!manager.inEditor) {
                    Utils.showLoading('Please wait until The video is loaded', 2000); // for student only
                }
                cekRealData(directPlayUrlWithTokenGenerated)
            } catch (error) {
                console.error("Error fetching stream token:", error);
            }
        }
        fetchStreamToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoData]);

    const cekRealData = async (directPlayUrlWithToken) => {
        fetch(directPlayUrlWithToken).then(function (response) {
            if (response.status === 200) {
                setIsMounted(true);
            } else {
                setIsMounted(false);
            }
            Utils.dismissAllToast();
        }).catch(function (error) {
            console.log(`error: ${error}`);
        });
    }

    return (
        isMounted ? <div style={{ position: 'relative', paddingTop: '56.25%' }}>
            <iframe src={directPlayUrlWithToken}
                title={videoData.title}
                loading="lazy"
                style={{ border: 'none', position: 'absolute', top: 0, height: customHeight ? customHeight : '100%', width: '100%', background: '#000000', borderRadius: '10px' }}
                allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                allowFullScreen={true}
            >
            </iframe>
        </div> : type === 'audio' ? <div className="tbcourse-template-audios-item">
            <span>
                <img src={require('../../assets/img/audio-frame.jpg')} className='img-fluid' alt='' />
            </span>
        </div> : <div className="tbcourse-template-video-content">
            <div className="tbcourse-template-video-preview">
                <img src={require('../../assets/img/video-frame.jpg')} className='img-fluid' alt='place an' />
            </div>
        </div>
    );
}
export default VideoPreviewBunnynet;
